<template>
<div class="chapter">
<div class="inner_page">
<p class="C62"><em><a id="page_VII">Contents</a></em></p><a id="page_VII">
</a><p class="C96"><a id="page_VII"><em></em></a><em><a href="#/html/07_Never_a_City_So_Real#page_1">Never a City So Real</a></em></p>
<p class="C96"><em><span href="#/html/08_Oil_Can_Eddie#page_15" title="Link target outside of Sample">Oil Can Eddie</span></em></p>
<p class="C96"><em><span href="#/html/09_Millie_and_Brenda#page_39" title="Link target outside of Sample">Millie and Brenda</span></em></p>
<p class="C96"><em><span href="#/html/10_Give_Them_What_They_Want#page_58" title="Link target outside of Sample">Give Them What They Want</span></em></p>
<p class="C96"><em><span href="#/html/11_26th_Street#page_76" title="Link target outside of Sample">26th Street</span></em></p>
<p class="C96"><em><span href="#/html/12_It_Takes_All_Kinds#page_88" title="Link target outside of Sample">It Takes All Kinds</span></em></p>
<p class="C96"><em><span href="#/html/13_Inside_Out#page_109" title="Link target outside of Sample">Inside Out</span></em></p>
<p class="C96"><em><span href="#/html/14_GT_s_Diner#page_130" title="Link target outside of Sample">GT’s Diner</span></em></p>
<p class="C96"><em><span href="#/html/15_Isn_t_That_the_Corniche#page_141" title="Link target outside of Sample">Isn’t That the Corniche?</span></em></p>
<p class="C96"><em><span href="#/html/16_Afterword#page_149" title="Link target outside of Sample">Afterword</span></em></p>
<p class="C96"><span href="#/html/17_ACKNOWLEDGMENTS#page_156" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?5d820754